var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "sidebar-fields",
      class: { "two-columns": _vm.block.Columns == 2 },
    },
    [
      _vm.rows.length == 0
        ? _c("div", { staticClass: "sidebar-fields-empty" }, [
            _vm._v(_vm._s(_vm.$ct("sidebar.no-fields"))),
          ])
        : _vm._e(),
      _vm._l(_vm.rows, function (row, i) {
        return _c(
          "div",
          {
            key: i,
            staticClass: "sidebar-field",
            class: { right: row.right, center: row.center },
          },
          [
            _c("div", { staticClass: "sidebar-field-label" }, [
              _vm._v(_vm._s(row.label)),
            ]),
            row.html === ""
              ? _c("div", { staticClass: "sidebar-field-value empty" }, [
                  _vm._v(_vm._s(_vm.$ct("sidebar.not-filled"))),
                ])
              : _c("div", {
                  directives: [
                    {
                      name: "safe-html",
                      rawName: "v-safe-html",
                      value: row.html,
                      expression: "row.html",
                    },
                  ],
                  staticClass: "sidebar-field-value",
                }),
          ]
        )
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }